// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__Yl62k","modalForm":"UpgradeEpcsModal_modalForm__dOlPz","modalFooter":"UpgradeEpcsModal_modalFooter__1x4Ob"};